<template>
	<div :style="viewStyles" class="">
		<div class="row justify-content-center align-items-center">
			<div class="col-11 mt-5">
				<p>{{ $t('Beim Check-in müssen Flaschen nach Typ und Ablaufdatum gruppiert gescannt werden.') }}</p>
				<label for="due_date" class="small">{{ $t('Ablaufdatum:') }}</label>
				<input type="date"
				       ref="dueDate"
				       id="due_date"
				       class="form-control"
				       required
				       :min="minDate"
				       v-model="selectedDate"
				/>
				<br>
				<label for="bottle_type" class="small">{{ $t('Flaschen Typ:') }}</label>
				<select id="bottle_type"
				        ref="bottleType"
				        class="form-control"
				        v-model="bottleType"
				        required
				>
					<option v-for="type in bottleTypes" :value="type">{{ $t(type) }}</option>
				</select>
			</div>
		</div>

		<bottom-navigation @new-height="setBottomPadding">
			<template v-slot:left>
				<button class="btn btn-light btn-block" @click="$router.back()">{{ $t('Zurück') }}</button>
			</template>
			<template v-slot:right>
				<button class="btn btn-primary btn-block"
				        :disabled="!isValid"
				        @click="$router.push('/entered_storage/properties/scanner')"
				>
					{{ $t('Weiter') }}
				</button>
			</template>
		</bottom-navigation>
	</div>

</template>

<script>
import {mapMutations, mapState} from "vuex";
import allViews from "../../mixins/allViews";
import BottomNavigation from "../../components/BottomNavigation";
import DataInput from "../../components/DataInput";
import dayjs from "dayjs";

export default {
	name: "ChooseBottleProperties",
	components: {DataInput, BottomNavigation},
	mixins: [allViews],
	data() {
		return {
			minDateIso: new Date().toISOString(),
			selectedCustomerId: null,
			isValid: false,
		}
	},
	computed: {
		...mapState(['bottleTypes', 'selectedBottleType', 'selectedDueDate']),
		bottleType: {
			get() {
				return this.selectedBottleType
			},
			set(value) {
				this.setSelectedBottleType(value)
			}
		},
		selectedDate: {
			get() {
				return this.selectedDueDate
			},
			set(nv) {
				this.setSelectedDueDate(nv)
			}
		},
		minDate() {
			return dayjs(this.minDateIso).format(this.$config.API_DATE_FORMAT)
		}
	},
	mounted() {
		this.isValid = this.$refs.dueDate.validity.valid && this.$refs.bottleType.validity.valid
	},
	updated() {
		this.isValid = this.$refs.dueDate.validity.valid && this.$refs.bottleType.validity.valid
	},
	methods: {
		...mapMutations(['setSelectedDueDate', 'setSelectedBottleType'])
	}
}
</script>
